import React from 'react';

import { usePopperTooltip } from 'react-popper-tooltip';

import { formatFigure, formatToFixedLocaleString, formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import Tooltip from 'CommonComponents/Tooltip';

export default function ContractorSchedulingIndexTableRowItem(props) {
    const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
        trigger: 'hover',
        interactive: true,
    });

    const tooltipContent = () => {
        return `<div class="tw-flex tw-flex-col tw-space-y-3">
            <h6 class="tw-text-base tw-font-semibold tw-text-white">${props.packChild.child_name}</h6>
            <div class="tw-flex tw-flex-col tw-space-y-1">
                <div class="tw-flex tw-flex-row tw-items-center tw-space-x-1">
                    <h6 class="tw-text-base tw-font-semibold tw-text-white">Min Duration</h6>
                    <p class="tw-text-white tw-text-sm">${props.packChild.min_duration}</p>
                </div>
                <div class="tw-flex tw-flex-row tw-items-center tw-space-x-1">
                    <h6 class="tw-text-base tw-font-semibold tw-text-white">Max Duration</h6>
                    <p class="tw-text-white tw-text-sm">${props.packChild.max_duration}</p>
                </div>
                <div class="tw-flex tw-flex-row tw-items-center tw-space-x-1">
                    <h6 class="tw-text-base tw-font-semibold tw-text-white">Shift Overlap</h6>
                    <p class="tw-text-white tw-text-sm">${props.packChild.shift_overlap}</p>
                </div>
            </div>
        </div>`;
    };

    return (
        <>
            <tr className="bg-grey">
                <td>{props.packChild.venue_name}</td>
                <td>{props.packChild.department_name}</td>
                <td>{props.packChild.pack_name}</td>
                <td>
                    <Tooltip placement="auto" tooltipContent={tooltipContent()} tooltipType="content">
                        <div className="tw-cursor-pointer">{props.packChild.child_name}</div>
                    </Tooltip>
                </td>
                <td className="inbud-date-cell">{props.packChild.date}</td>
                <td className="inbud-numeric-cell">{props.packChild.shift_number}</td>
                <td className="inbud-date-cell">{props.packChild.start}</td>
                <td className="inbud-date-cell">{props.packChild.end}</td>
                <td className="inbud-numeric-cell">{formatFigure(props.packChild.hours, formatToFixedLocaleString, { precision: 2 })}</td>
                <td className="inbud-numeric-cell">{formatFigure(props.packChild.hourly_rate, formatToFixedMoneyWithLocale, { precision: 2 })}</td>
                <td className="inbud-numeric-cell">{formatFigure(props.packChild.total_child, formatToFixedMoneyWithLocale, { precision: 2 })}</td>
            </tr>
        </>
    );
}
